module.exports = __webpack_public_path__ + "img/func_4_4.f19ad883.svg";